module.exports = {"name":"poll","menu":{"label":"Consultas","items":[{"label":"Criar Consulta","route":"/criar-consulta","weight":1},{"label":"Lista das Consultas","route":"/consultas","weight":2}],"parent":"menuEngagement","weight":5}}


//////////////////
// WEBPACK FOOTER
// ./_source/javascripts/modules/poll/config.json
// module id = 390
// module chunks = 0